import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import ActionTypes from '../constants'
import { WageringState } from '../models'
import { WAGERING } from './api.routes'

const apiService: RestApiService = Container.get(RestApiService)

export const getWCCategoriesThunk = createAsyncThunk(
  ActionTypes.GET_WC_CATEGORIES,
  async (_, thunkAPI) => {
    try {
      const { auth, wagering } = thunkAPI.getState() as ApplicationState
      const siteID = auth.brand.siteId.toString()

      apiService.requestParams = {
        method: 'GET',
        endpoint: WAGERING.WC_CATEGORY,
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.getData(siteID, auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      let responseData = response

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      } else {
        const categoriesMap = new Map(
          wagering.categoriesList.map((cat: any) => [String(cat.id), cat.name]),
        )

        const docs = response.contributions.map((item: any, idx: number) => {
          const resolvedName = categoriesMap.get(String(item.code)) ?? item.Name

          return {
            ...item,
            Name: resolvedName,
            id: idx,
          }
        })

        responseData = { ...response, contributions: docs }
      }

      return responseData
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getWCCategoriesExtraReducer = (
  builder: ActionReducerMapBuilder<WageringState>,
) => {
  builder.addCase(getWCCategoriesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getWCCategoriesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.wageringCategory = payload.contributions
    state.wageringContributionId = payload._id
  })
}

export default getWCCategoriesExtraReducer
